import axios from "axios";
import BaseApi from "./baseApi";

export default class NotificationApi extends BaseApi {
  // User notification
  getNotifications(search) {
    return axios
      .get(`${this.url}/api/users/${this.me}/notifications`, { params: search })
      .then(response => {
        return {
          notifications: response.data.result,
          count: response.data.count,
          total: response.data.total
        };
      });
  }

  // Get notifications count
  getNotificationsCount() {
    return axios.get(`${this.url}/api/users/${this.me}/notifications/count`).then(response => {
      return response.data.result;
    });
  }

  // Set State as "OLD"
  setStateNotificationsAsOld() {
    return axios.patch(`${this.url}/api/users/${this.me}/notifications/old`).then(() => {
      return true;
    });
  }
  // Delete User notifications
  deleteUserNotifications(userId) {
    return axios.delete(
      this.url + "/api/" + this.organizationCode + "/users/" + userId + "/notifications"
    );
  }

  async SetSingleStatusRead(notifyId) {
    //TODO cambierà
    return axios.patch(`${this.url}/api/users/${this.me}/notifications/${notifyId}/read`, {});
  }

  setStatusRead(userId, notifyIds) {
    if (!!notifyIds && notifyIds.length > 0) {
      const promises = []; // array to hold all requests promises with their then
      notifyIds.forEach(notifyId => {
        // adding every request to the array
        promises.push(this.SetSingleStatusRead(notifyId));
      });

      // Resolving requests with their callbacks before procedding to the last then callback
      return Promise.all(promises).then(
        /* use the data, return list of responses axios */
        responses => {
          return responses;
        }
      );
    } else {
      return null;
    }
  }
}
